var _defs, _path, _circle, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnMenuFamily(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.b{stroke:#347c9d;}.b,.c{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.c{stroke:#51b2cd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(5 3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3,21V19a4,4,0,0,1,4-4h4a4,4,0,0,1,4,4v2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16,3.13a4,4,0,0,1,0,7.75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M21,21V19a4,4,0,0,0-3-3.85"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMenuFamily);
export default __webpack_public_path__ + "static/media/icn-menu-family.d500bd48cd48a7b534431c04159b9da4.svg";
export { ForwardRef as ReactComponent };